import React from 'react'
import abimg from '../../images/about_us.jpg'
import misyon from '../../images/mission.jpg'
import vizyon from '../../images/vision.jpg'


const About = (props) => {

    return(
        <div className="tp-about-section">
            <div className="container">
                <div className="row justify-content-between">
                    <div className="col-lg-6 col-md-12 col-12 order-lg-1">
                        <div className="tp-about-wrap">
                        <div className="tp-about-img" style={{ 
                            maxWidth: '400px',
                            width: '100%',
                            margin: '0 auto'
                        }}>
                            <img src={abimg} alt="" style={{width: '100%', height: 'auto'}}/>
                        </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-12 order-lg-2">
                        <div className="tp-about-text">
                        <div className="tp-about-icon-content">
                            <h2>Hakkımızda</h2>
                            <p>2015 yılında "ALZA MAKİNE SANAYİ VE TİCARET LİMİTED ŞİRKETİ" ticari unvanı ile Kayseri'de faaliyetlerine başlayan şirketimiz; farklı sektörlerde ve pozisyonlarda uzun yıllar tecrübe sahibi olan kurucu ortaklarımızın girişimi ile KOSGEB tarafından desteklenen özel bir proje çalışması ile kurulmuştur.</p>
                            <p>İşletmemiz, onlarca farklı ülkeden, yüzlerce ürünün Türkiye Distribütörlüğünü yapan birçok firmanın Orta Anadolu Bölge Temsilciliği'ni yürütmektedir.</p>
                        </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container about-section-container">
                <div className="row justify-content-between">
                    <div className="col-lg-6 col-md-12 col-12 order-lg-2">
                        <div className="tp-about-wrap">
                        <div className="tp-about-img" style={{ 
                            maxWidth: '400px',
                            width: '100%',
                            margin: '0 auto'
                        }}>
                            <img src={misyon} alt="" style={{width: '100%', height: 'auto'}}/>
                        </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-12 order-lg-1">
                        <div className="tp-about-text">
                        <div className="tp-about-icon-content">
                            <h2>Misyonumuz</h2>
                            <p>Girişim fikrinin fizibilite çalışmaları anından itibaren kurumsal bir bilinç ile temelleri atılan şirketimiz;</p>
                            <ul style={{ 
                                listStyle: 'none',
                                paddingLeft: '20px',
                                color: '#999',
                                marginBottom: '15px'
                            }}>
                                <li style={{ 
                                    position: 'relative', 
                                    paddingLeft: '20px',
                                    marginBottom: '8px'
                                }}>
                                    <span style={{
                                        position: 'absolute',
                                        left: '0',
                                        top: '8px',
                                        width: '8px',
                                        height: '8px',
                                        backgroundColor: '#D4AF37',
                                        borderRadius: '50%',
                                        opacity: '0.8'
                                    }}></span>
                                    Sürekli büyümeyi hedefleyen,
                                </li>
                                <li style={{ 
                                    position: 'relative', 
                                    paddingLeft: '20px',
                                    marginBottom: '8px'
                                }}>
                                    <span style={{
                                        position: 'absolute',
                                        left: '0',
                                        top: '8px',
                                        width: '8px',
                                        height: '8px',
                                        backgroundColor: '#D4AF37',
                                        borderRadius: '50%',
                                        opacity: '0.8'
                                    }}></span>
                                    Tüm faaliyetlerinin merkezine önce müşterisini yerleştiren,
                                </li>
                                <li style={{ 
                                    position: 'relative', 
                                    paddingLeft: '20px',
                                    marginBottom: '8px'
                                }}>
                                    <span style={{
                                        position: 'absolute',
                                        left: '0',
                                        top: '8px',
                                        width: '8px',
                                        height: '8px',
                                        backgroundColor: '#D4AF37',
                                        borderRadius: '50%',
                                        opacity: '0.8'
                                    }}></span>
                                    Çözüm odaklı,
                                </li>
                                <li style={{ 
                                    position: 'relative', 
                                    paddingLeft: '20px',
                                    marginBottom: '8px'
                                }}>
                                    <span style={{
                                        position: 'absolute',
                                        left: '0',
                                        top: '8px',
                                        width: '8px',
                                        height: '8px',
                                        backgroundColor: '#D4AF37',
                                        borderRadius: '50%',
                                        opacity: '0.8'
                                    }}></span>
                                    Nitelikli ürün & hizmeti, tam zamanında ve en uygun fiyata sunmayı amaçlayan,
                                </li>
                                <li style={{ 
                                    position: 'relative', 
                                    paddingLeft: '20px',
                                    marginBottom: '8px'
                                }}>
                                    <span style={{
                                        position: 'absolute',
                                        left: '0',
                                        top: '8px',
                                        width: '8px',
                                        height: '8px',
                                        backgroundColor: '#D4AF37',
                                        borderRadius: '50%',
                                        opacity: '0.8'
                                    }}></span>
                                    Kendisi gelişirken iş ortaklarını da geliştiren,
                                </li>
                                <li style={{ 
                                    position: 'relative', 
                                    paddingLeft: '20px',
                                    marginBottom: '8px'
                                }}>
                                    <span style={{
                                        position: 'absolute',
                                        left: '0',
                                        top: '8px',
                                        width: '8px',
                                        height: '8px',
                                        backgroundColor: '#D4AF37',
                                        borderRadius: '50%',
                                        opacity: '0.8'
                                    }}></span>
                                    Teknolojik altyapıya sahip çözüm yöntemleriyle sektöründe liderliğe aday olan,
                                </li>
                            </ul>
                            <p>Gerçekleştirdiği bütün faaliyetlerinde sosyal sorumluluk bilinci ile de insana ve çevreye duyarlı bir işletme olmayı kendisine misyon edinmiştir.</p>
                        </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container about-section-container">
                <div className="row justify-content-between">
                    <div className="col-lg-6 col-md-12 col-12 order-lg-1">
                        <div className="tp-about-wrap">
                        <div className="tp-about-img" style={{ 
                            maxWidth: '400px',
                            width: '100%',
                            margin: '0 auto'
                        }}>
                            <img src={vizyon} alt="" style={{width: '100%', height: 'auto'}}/>
                        </div>
                        </div>
                            </div>
                    <div className="col-lg-6 col-md-12 col-12 order-lg-2">
                        <div className="tp-about-text">
                        <div className="tp-about-icon-content">
                            <h2>Vizyonumuz</h2>
                            <p>Ülke çapında sunacağımız ürün ve hizmetlerle; teknoloji geliştiren, tüm ülkede bilinen, yenilikçi, öncü ve kalite ile özdeşleşmiş bir marka olma vizyonunu benimseyen şirketimiz kısa, orta ve uzun vadeli hedeflerini gerçekleştirme yolunda emin adımlarla ilerlemektedir. </p>                        </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="white_svg svg_white">
                <svg x="0px" y="0px" viewBox="0 186.5 1920 113.5">
                    <polygon points="0,300 655.167,210.5 1432.5,300 1920,198.5 1920,300 "></polygon>
                </svg>
            </div>
        </div>
    )
}

export default About;